import React from 'react';
import Peca from './Peca';

// aviso de lembrete de tarefa do chat, em qualquer tela: o mesmo da Central, vindo do pacote (ver pacote.js)
export default function AvisoLembrete(){
    return <Peca peca="aviso" />;
}
